import Table from 'react-bootstrap/Table';
import { Badge, Spinner } from 'react-bootstrap';
import moment from 'moment';
import {
  useGetVisitorInvoiceList,
  useGetVisitorProfileData,
} from '../apiEndpoints/VisitorApiEndpoints';
import CommonStatus from '../../../Components/Common/CommonStatus';
import { Link } from 'react-router-dom';
import { FaEye } from 'react-icons/fa';
import { encodeData } from '../../../Components/Common/utility/commonUtility';
import CommonOnlinePayment from '../../Common/Payment/CommonOnlinePayment';

const VisitorInvoice = () => {
  const { data, isLoading, isSuccess } = useGetVisitorInvoiceList();
  const { data: visitor } = useGetVisitorProfileData();
  return (
    <>
      <div className='profile-right-side px-3 py-3'>
        <h4 className='component-tittle'>Invoice Information</h4>
        <div className='profile-right-info pt-3 ps-2'>
          {isLoading ? (
            <div className='text-center mt-3'>
              <Spinner animation='border' variant='primary' />
            </div>
          ) : (
            <Table striped bordered hover size='sm'>
              <thead>
                <tr className='text-center'>
                  <th>SL.</th>
                  <th>Date</th>
                  <th>Invoice No.</th>
                  <th>Amount</th>
                  <th>Due</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.map((item, index) => (
                  <tr key={item.id} className='text-center'>
                    <td>{index + 1}</td>
                    <td>{moment(item?.invoice_date).format('MMM Do YY')}</td>
                    <td>{item?.invoice_no}</td>
                    <td>{item?.net_total}</td>
                    <td>{item?.due}</td>
                    <td>{CommonStatus(item?.status)}</td>
                    <td style={{ textAlign: 'center' }}>
                      <Link
                        to={`/visitor/view-billing-info/${item.id}`}
                        className='me-2'
                      >
                        <FaEye size={20} color='#00acee' />
                      </Link>

                      <CommonOnlinePayment
                        invoiceId={item.id}
                        userId={visitor?.data?.visitor_id}
                        userType={'Visitor'}
                        isPaid={
                          Number(item?.due) <= 0 || item?.status === 'Paid'
                            ? 'Paid'
                            : undefined
                        }
                      />
                      {/* <Link
                        to={`/visitor/payment-management?value=${encodeData({
                          amount: item.due,
                          invoice_id: item.id,
                          isVisitor: true,
                        })}`}
                      >
                        <Badge
                          bg={'primary'}
                          text={'light'}
                          style={{
                            fontSize: '12px',
                            cursor: 'pointer',
                          }}
                        >
                          Pay Now
                        </Badge>
                      </Link> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};

export default VisitorInvoice;
